import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import FPSSection from '../components/FPSSection';
import ShopSection from '../components/ShopSection';
import ReviewsSection from '../components/ReviewsSection';
import FAQSection from '../components/FAQSection';
import AISupportChat from '../components/AISupportChat';

export default function LandingPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <FPSSection />
      <ShopSection />
      <ReviewsSection />
      <FAQSection />
      <footer className="py-12 border-t border-white/5 text-center">
        <p className="font-inter text-xs text-zinc-800 tracking-widest uppercase">
          © {new Date().getFullYear()} Vanta — All rights reserved
        </p>
      </footer>
      <AISupportChat />
    </div>
  );
}
